<template>
  <div class="flex w-full">
    <div class="w-1/3">
      <div class="w-full mb-3 h-3px bg-au_primary" />
      <div class="flex flex-col items-center leading-none text-center text-xxs xl:flex-row xl:text-left xl:pl-10 xl:text-sm">
        <div class="flex-shrink-0 mb-2 xl:mb-0 xl:mr-2">
          <div v-if="activeStep > 1">
            <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-5 h-5'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11 1.563c5.204 0 9.438 4.233 9.438 9.437S16.203 20.438 11 20.438c-5.204 0-9.438-4.234-9.438-9.438 0-5.204 4.234-9.438 9.438-9.438zM11 1C5.477 1 1 5.477 1 11s4.477 10 10 10 10-4.477 10-10S16.523 1 11 1zm4.574 7.282l-.398-.398-5.634 5.635L6.824 10.8l-.398.398 3.116 3.116 6.032-6.033z" fill="#000" stroke="#000" stroke-width=".5"/></svg>
          </div>
          <div
            v-if="activeStep <= 1"
            class="flex items-center justify-center w-5 h-5 text-xs leading-none border rounded-full"
            :class="[ activeStep === 1 ? 'bg-au_primary border-transparent text-white' : 'text-au_gray-700 border-au_gray-200' ]"
          >
            1
          </div>
        </div>
        <span class="px-1" :class="{ 'font-bold text-au_primary': activeStep === 1, 'text-black': activeStep > 1 }">{{ step1 }}</span>
      </div>
    </div>
    <div class="w-1/3">
      <div :class="['w-full h-3px mb-3', activeStep >= 2 ? 'bg-au_primary': 'bg-au_gray-200']" />
      <div class="flex flex-col items-center leading-none text-center text-xxs xl:flex-row xl:text-left xl:pl-10 xl:text-sm">
        <div class="flex-shrink-0 mb-2 xl:mb-0 xl:mr-2">
          <div v-if="activeStep > 2">
            <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-5 h-5 xl:w-5 xl:h-5'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11 1.563c5.204 0 9.438 4.233 9.438 9.437S16.203 20.438 11 20.438c-5.204 0-9.438-4.234-9.438-9.438 0-5.204 4.234-9.438 9.438-9.438zM11 1C5.477 1 1 5.477 1 11s4.477 10 10 10 10-4.477 10-10S16.523 1 11 1zm4.574 7.282l-.398-.398-5.634 5.635L6.824 10.8l-.398.398 3.116 3.116 6.032-6.033z" fill="#000" stroke="#000" stroke-width=".5"/></svg>
          </div>
          <div
            v-if="activeStep <= 2"
            class="flex items-center justify-center w-5 h-5 text-xs leading-none border rounded-full"
            :class="[ activeStep === 2 ? 'bg-au_primary border-transparent text-white' : 'text-au_gray-700 border-au_gray-200' ]"
          >
            2
          </div>
        </div>
        <span class="px-1" :class="{ 'font-bold text-au_primary': activeStep === 2, 'text-gray-900': activeStep > 2, 'text-au_gray-700': activeStep < 2 }">{{ step2 }}</span>
      </div>
    </div>
    <div class="w-1/3">
      <div :class="['w-full h-3px mb-3', activeStep >= 3 ? 'bg-au_primary': 'bg-au_gray-200']" />
      <div class="flex flex-col items-center leading-none text-center text-xxs xl:flex-row xl:text-left xl:pl-10 xl:text-sm">
        <div class="flex-shrink-0 mb-2 xl:mb-0 xl:mr-2">
          <div
            v-if="activeStep <= 3"
            class="flex items-center justify-center w-5 h-5 text-xs leading-none border rounded-full"
            :class="[ activeStep === 3 ? 'bg-au_primary border-transparent text-white' : 'text-au_gray-700 border-au_gray-200' ]"
          >
            3
          </div>
        </div>
        <span class="px-1" :class="{ 'font-bold text-au_primary': activeStep === 3, 'text-gray-900': activeStep > 3, 'text-au_gray-700': activeStep < 3 }">{{ step3 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import VoucherNavigation from '~components/navigation/step-navigation'

export default VoucherNavigation.extend()
</script>
